import { Actions } from "./styles";

export function ListPreviewInfoActions({ children, ...rest }) {
  return <Actions {...rest}>{children}</Actions>;
}
